import type { PresentationIsEmptyProps } from '../..'
export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const content = block?.fields?.content

  if (!content) return true

  return false
}
